import React from "react";

const customThemeContext = React.createContext({
  overrideTheme: () => {},
});

export default customThemeContext;
